import { HotjarScript } from '@avanta/shared/components/HotjarScript';
import { LoadingScreen } from '@avanta/shared/components/LoadingScreen';
import { DialogProvider } from '@avanta/shared/contexts/Dialog';
import { TooltipProvider } from '@avanta/shared/contexts/Tooltip';
import { initSentry, Sentry } from '@avanta/shared/sentry';
import { configureStorage } from '@avanta/shared/utils/storage';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { STORAGE_PREFIX } from 'constants/storage';
import { QueryClientProvider } from './query-manager.tsx';
import { AppRouter } from './routes';
import '@avanta/shared/i18n';
import '@avanta/shared/index.css';

configureStorage(STORAGE_PREFIX);
initSentry();
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

// eslint-disable-next-line no-console
console.info(`📦 avanta-webapp | v${__APP_VERSION__}`);

createRoot(rootElement).render(
  <StrictMode>
    <Sentry.ErrorBoundary>
      <HotjarScript />
      <Suspense fallback={<LoadingScreen />}>
        <QueryClientProvider>
          <DialogProvider>
            <TooltipProvider>
              <Toaster expand richColors visibleToasts={3} className="notranslate max-am-sm:w-60" />
              <AppRouter />
            </TooltipProvider>
          </DialogProvider>
        </QueryClientProvider>
      </Suspense>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
